import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import {
	SET_POST_DESCRIPTION_EN,
	SET_POST_TITLE_EN,
	SET_POST_PROMOTION_EN
} from "actions/types";

class Step4 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const { dispatch, lang } = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Titre"
						id="title-en"
						fullWidth
						value={lang?.en?.title || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_TITLE_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description"
						id="descrption-en"
						fullWidth
						multiline
						rows={5}
						value={lang?.en?.description || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_DESCRIPTION_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Promotion"
						id="promotion-en"
						fullWidth
						value={lang?.en?.promotion || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_PROMOTION_EN,
								value: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { lang } = state.eventReducer;
	return {
		lang
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step4
);
